import {
    Flex,
    Box,
    FormLabel,
    Input,
    Button,
    useToast,
    Text
} from '@chakra-ui/react'
import { addDoc, collection, updateDoc, doc, deleteDoc } from 'firebase/firestore'
import React, { useState, useEffect, Fragment } from 'react'
import db from '../firebase'
import useApp from '../context/AppContext'
  
function AddCat() {

    const toast = useToast()
    const {rawCatData} = useApp()
    const [data, setData] = useState({})
    const [selectedCat, setSelectedCat] = useState("")

    const postData = async () => {

        if(!data.label || !data.limit || !data.basePrice)
        {
            toast({
                position: 'bottom-right',
                title: `Please fill all the fields`,
                status: `error`,
                duration: 1000,
                isClosable: true,
            })
            return;
        }

        delete data.cit
        if(!selectedCat)
            await addDoc(collection(db, 'catData'), {
            ...data,
            basePrice: parseInt(data.basePrice),
            limit: parseInt(data.limit)
        })

        else
            await updateDoc(doc(db, 'catData', selectedCat), {
                ...data,
                basePrice: parseInt(data.basePrice),
                limit: parseInt(data.limit)
            })

        if(!selectedCat)
        toast({
            position: 'bottom-right',
            title: `Category Added Successfully`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })
        else
        toast({
            position: 'bottom-right',
            title: `Category Updated Successfully`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })
    }

    useEffect(() => {

        console.log(selectedCat)
        if(selectedCat)
        {
            const d = rawCatData.find(d => d.cit === selectedCat)
            // delete d.cit
            setData(d)
        }
        else
            setData({})

    }, [selectedCat])

    const handleChange = (e) => {
        setData(s => ({
            ...s, 
            [e.target.name]: e.target.value
        }))
    }

    if(!rawCatData) return <></>
    
    return (
        <Flex
            direction={'column'}
            pb={5}
            gap={5}
            justifyContent={'center'}
            alignItems={'center'}
        >
            
            <Box w={'30%'} pt={5}>
                <FormLabel htmlFor='label'>label</FormLabel>
                <Input  
                    id='label' 
                    type='text' 
                    name="label" 
                    onChange={(e) =>handleChange(e)}
                    value={data?.label || ""}
                />
            </Box>
            <Box w={'30%'}>
                <FormLabel htmlFor='limit'>limit</FormLabel>
                <Input  
                    id='limit' 
                    type='number' 
                    name="limit" 
                    onChange={(e) =>handleChange(e)}
                    value={data?.limit || ""}
                />
            </Box>
            <Box w={'30%'}>
                <FormLabel htmlFor='basePrice'>base Price</FormLabel>
                <Input  
                    id='basePrice' 
                    type='number' 
                    name="basePrice" 
                    onChange={(e) =>handleChange(e)}
                    value={data?.basePrice || ""}
                />
            </Box>

            <Flex
                gap={3}
                px={5}
                mt={5}
            >
                {rawCatData && (
                <Fragment>
                    {rawCatData.map((d) => (
                        <Button 
                        key={d.cit} 
                        onClick={() => setSelectedCat(selectedCat === d?.cit ? "" : d?.cit)}
                        bg={selectedCat === d?.cit ? 'blue.500' : 'gray.700'} 
                        >
                        {d.label}
                        </Button> 
                    ))}
                    {selectedCat &&
                    <Button bg={'red.600'} onClick={async () => {
                        await deleteDoc(doc(db,'catData',selectedCat))
                        toast({
                            position: 'bottom-right',
                            title: `Category Deleted Successfully`,
                            status: `success`,
                            duration: 1000,
                            isClosable: true,
                        })
                    }}>Delete</Button>
                    }
                </Fragment>)}

            </Flex>

            <Button mx={"auto"} w={'90%'} onClick={postData}>Submit</Button>

        </Flex>
    )
}

export default AddCat